import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./auth.css";

function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email || "your email";

  return (
    <div className="auth-wrapper">
      <div className="auth-box" style={{ textAlign: "center" }}>
        
        <h1 style={{ marginBottom: "10px" }}>
          Check Your Email
        </h1>

        <p style={{ marginBottom: "10px" }}>
          We sent a verification link to:
        </p>

        <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
          {email}
        </p>

        {/* ⚠️ IMPORTANT MESSAGE */}
        <div style={{
          background: "#fff3cd",
          color: "#856404",
          padding: "12px",
          borderRadius: "8px",
          fontWeight: "bold",
          marginBottom: "20px"
        }}>
          Check your spam or junk folder if you don’t see it.
        </div>

        <button
          className="auth-btn"
          onClick={() => navigate("/auth")}
        >
          Back to Login
        </button>

      </div>
    </div>
  );
}

export default VerifyEmail;